import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-entra-login-button',
  templateUrl: './entra-login-button.component.html',
  styleUrls: ['./entra-login-button.component.scss'],
})
export class EntraLoginButtonComponent {
  @Output() buttonClick = new EventEmitter<void>();
}
